import React from "react";
import Header from "../common/Header";
import Hero from "../common/Hero";
import Features from "../common/Features";
import About from "../common/About";
import Facts from "../common/Facts";
import Services from "../common/Services";
import Categories from "../common/Categories";
import Steps from "../common/Steps";
import Testimonial from "../common/Testimonial";
import Footer from "../common/Footer";

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <Features />
      <About />
      <Facts />
      <Services />
      <Categories />
      <Steps />
      <Testimonial />
      <Footer />
    </>
  );
};

export default Home;
